module.exports = __webpack_public_path__ + "img/move.2400329a.svg";